import { mode } from "@chakra-ui/theme-tools";

export const globalStyles = {
  colors: {
    gray: {
      700: "#1f2733",
    },
    // Modern Dark Green Theme Palette
    brand: {
      50: "#E8F5EC",
      100: "#C5E6CE",
      200: "#9ED5AD",
      300: "#77C48C",
      400: "#5AB873",
      500: "#3D8A53",  // Primary brand green
      600: "#2D6B3F",  // Main dark green (primary)
      700: "#1F5A2F",  // Darker green
      800: "#164A24",
      900: "#0D3A19",
    },
    brandAccent: {
      50: "#E6F7F4",
      100: "#B3E8DE",
      200: "#80D9C8",
      300: "#4DCAB2",
      400: "#26BFA2",
      500: "#00B492",
      600: "#009A7D",
      700: "#008068",
      800: "#006653",
      900: "#004C3E",
    },
  },
  styles: {
    global: (props) => ({
      body: {
        bg: mode("gray.50", "gray.900")(props),
        fontFamily: 'Inter, Poppins, sans-serif'
      },
      html: {
        fontFamily: 'Inter, Poppins, sans-serif'
      },
      // Fix for native select dropdown options in dark mode
      'select option, select optgroup': {
        bg: 'white',
        color: 'gray.800',
      },
      // Darker table borders
      'th, td': {
        borderColor: mode("#CBD5E0", "#4A5568")(props) + " !important",
      },
      // Darker chart grid lines
      '.apexcharts-gridline, .apexcharts-xaxis-tick': {
        stroke: mode("#CBD5E0", "#2D3748")(props),
      },
      '.apexcharts-grid-borders line': {
        stroke: mode("#CBD5E0", "#2D3748")(props),
      },
    }),
  },
};
